<template>
    <ym-layout>
        <div slot="bgimg">
            <div class="block">
                <el-carousel height="384px" arrow="never">
                    <el-carousel-item class="adindex">
                        <ul class="ad1">
                            <li><img src="../assets/images/welcome1.jpg"></li>
                        </ul>
                    </el-carousel-item>
                    <el-carousel-item class="adindex">
                        <ul class="ad2">
                            <li><img src="../assets/images/welcome2.png"></li>
                        </ul>
                    </el-carousel-item>
                    <el-carousel-item class="adindex">
                        <ul class="ad3">
                            <li><img src="../assets/images/welcome3.png"></li>
                        </ul>
                    </el-carousel-item>
                </el-carousel>
            </div>
        </div>

        <div class="wauto bgfff hauto">
            <div class="container">
                <div class="supply txtcenter">
                    <h1 class="green">供应信息</h1>
                    <p class="margintop15">木材原料种类齐全，来自全球各地的原木、锯材、人造板、木皮，木制品<br/>有木头专注经营木材上游到下游</p>
                    <div class="supplyList">
                        <div class="supplyOne pr">
                            <img src="../assets/images/s1.jpg" width="288">
                            <a class="pa info none">森林/原木</a>
                        </div>
                        <div class="supplyOne pr">
                            <img src="../assets/images/s2.jpg" width="288">
                            <a class="pa info none">锯材/工程用料</a>
                        </div>
                        <div class="supplyOne pr">
                            <img src="../assets/images/s3.jpg" width="288">
                            <a class="pa info none">人造板</a>
                        </div>
                        <div class="supplyOne pr">
                            <img src="../assets/images/s4.jpg" width="288">
                            <a class="pa info none">木皮/单板</a>
                        </div>
                        <div class="supplyOne pr">
                            <img src="../assets/images/s5.jpg" width="288">
                            <a class="pa info none">托盘/包装材</a>
                        </div>
                        <div class="supplyOne pr">
                            <img src="../assets/images/s6.jpg" width="288">
                            <a class="pa info none">尾料</a>
                        </div>
                        <div class="supplyOne pr">
                            <img src="../assets/images/s7.jpg" width="288">
                            <a class="pa info none">木工机械</a>
                        </div>
                        <div class="supplyOne pr intomall">
                            <router-link class="pa green" :to="{ name: '002-1'}">
                                前往现货商城
                            </router-link>
                            <span class="ico-index goto pa"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container futures">
            <div class="left"><img src="../assets/images/map.png"></div>
            <div class="statistics right">
                <div class="one left pr">
                    <div class="total txtcenter">
                        <strong>80</strong>+<span>国家</span>
                    </div>
                    <p class="green txtcenter">采购地区遍布全球<br>八十多个国家</p>
                    <div class="pa ico-index sanjiao"></div>
                </div>
                <div class="one left pr">
                    <div class="total txtcenter">
                        <strong>10000</strong>+<span>木材厂商</span>
                    </div>
                    <p class="green txtcenter">全年木材采购量<br>达到一亿立方</p>
                    <div class="pa ico-index sanjiao"></div>
                </div>
                <div class="goto">
                    来自各国木材生产商最新期货数据



                    <router-link class="green" :to="{ name: '003-1'}">
                        去看看！



                    </router-link>
                </div>
            </div>
        </div>

        <div class="wauto bgfff hauto muma " style="background: #FFFFFF; height: auto; padding: 110px 0 88px 0;">
            <div class="container">
                <dl class="wauto left">
                    <dt class="color000">信息化仓储物流管理</dt>
                    <dd>
                        仓库分布在国内木材市场集中的城市，对木材供应商、木材加工商、家具制造商开放全方位合作空间；木马物流为供需双方提供线上找车服务，让找车更简单，发货更容易，物流成本更低。结合信息化、数字化技术开启科学、人性化物流管理。



                    </dd>
                    <dd>
                        <a class="left txtcenter green">
                            <span class="ico-index cc"></span>
                            有木仓储
                        </a>
                        <router-link class="left txtcenter green" :to="{ name: '004-3'}">
                            <span class="ico-index wl"></span>
                            木马物流



                        </router-link>
                        <a class="left txtcenter green">
                            <span class="ico-index xt"></span>
                            ERP系统
                        </a>
                    </dd>
                </dl>
                <div class="wauto right">
                    <img src="../assets/images/ck.jpg" width="407" height="312" alt="信息化仓储物流管理">
                </div>
            </div>
        </div>

        <div class="container finance hauto">
            <div class="wauto left intro">
                <img src="../assets/images/jr2.png" width="200" height="206" alt="有木金融,木材金融" class="left">
                <dl class="left hauto">
                    <dt class="color000">有木金融</dt>
                    <dd class="hauto">木材行业的专属金融，为有木头会员提供资金支持服务。利息低，可质押，可信贷；放款速度快，满足及时的资金到账需求；省时省心，做您的强大背后支持。



                        <router-link class="green underline" :to="{ name: '004-2'}" target="_blank">
                            了解更多



                        </router-link>
                    </dd>
                </dl>
            </div>
            <div class="wauto hauto right list" style="height: auto; border: 0px; width: auto">
                <dl class="left pr bbf">
                    <dt class="green">现货动态质押贷款</dt>
                    <dd>1000W~3000W</dd>
                    <dd class="one f1 pa"></dd>
                </dl>
                <dl class="left pr bbf">
                    <dt class="green">进口融资代付T/T L/C</dt>
                    <dd>20W~1000W</dd>
                    <dd class="one f2 pa"></dd>
                </dl>
                <dl class="left pr bbf">
                    <dt class="green">信用贷款</dt>
                    <dd>2W~100W</dd>
                    <dd class="one f3 pa"></dd>
                </dl>
            </div>
        </div>

        <div class="wauto app">
            <div class="container">
                <div class="banner hauto">
                    <div class="cartoon left"><img src="../assets/images/cartoon.png" width="223" height="355"></div>
                    <dl class="appabout right hauto">
                        <dt class="color000">手机在手，机会不愁！</dt>
                        <dd>
                            <div class="appone left bgfff txtcenter">
                                <img src="../assets/images/code1.jpg" width="116" height="116">
                                <dl>
                                    <dt class="green">有木头公众号</dt>
                                    <dd>随时随地，订货卖货</dd>
                                </dl>
                            </div>
                            <div class="appone left bgfff txtcenter">
                                <img src="../assets/logo/xiao_shop.jpg" width="116" height="116">
                                <dl>
                                    <dt class="green">有木头小程序</dt>
                                    <dd>一机在手，方便快捷</dd>
                                </dl>
                            </div>
                        </dd>
                    </dl>
                </div>
            </div>
        </div>
    </ym-layout>
</template>

<script>
    export default {
        data () {
            return {
                leftApp: 0,
                rightApp: 0
            }
        },

        methods: {}
    }
</script>

<style>
    .el-carousel__button {
        width: 80px;
        height: 10px;
    }

    .el-carousel__item:nth-child(2n) {
        background-color: #093;
        background-image: url("../assets/images/welcome2.png");
    }

    .el-carousel__item:nth-child(2n+1) {
        background-image: url("../assets/images/welcome3.png");
    }
</style>



// WEBPACK FOOTER //
// welcome.vue?4adae9b4